import { Nullable } from "../Extensions";
import { PropertyChange } from "../PropertyChange";
import { DataSource } from "./DataSource";
import { NAMESPACE } from "./_Namespace";

export class DataSourcePropertyValueChange<TValue> extends PropertyChange<TValue>
{
    public static override classNamespace = NAMESPACE + "DataSourcePropertyValueChange";
    public static override className = "DataSourcePropertyValueChange";

    // #region Global Variables

    protected _dataSource: DataSource;
    protected _path: string;

    // #endregion

    // #region Properties

    get dataSource(): DataSource
    {
        return this._dataSource;
    }

    get path(): string
    {
        return this._path;
    }

    // #endregion

    // #region Constructor

    constructor(dataSource: DataSource, path: string, currentValue: Nullable<TValue>, originaValue: Nullable<TValue>)
    {
        super(currentValue, originaValue);

        this._dataSource = dataSource;
        this._path = path;
    }

    // #endregion
}